/**
 * Vue-Pendant zu Angulars `AppContextService` (`customer-apps/app-context/app-context.service.ts`)
 * und den drei Direktiven, die darauf aufsetzen: `*kgrIfAppId`, `*kgrIfAppType`,
 * `*kgrIfInstitutionType`. Die Methodennamen sind bewusst identisch, damit ein Angular-Gate beim
 * Portieren wörtlich übernommen werden kann.
 *
 * Die drei Werte kommen aus `window.kgrDynamicConfig` (in `main.ts` aus `APP_CONFIG` gesetzt) und
 * ändern sich zur Laufzeit nie — deshalb Funktionen und keine Refs. Funktionen statt
 * Modul-Konstanten, weil `main.ts` die Config erst beim Start zusammensetzt: eine Konstante auf
 * Modulebene einer `shared/`-Datei kann davor ausgewertet werden.
 */

export type AppId
    = | 'kindergarten_parent_app'
        | 'kindergarten_employee_app'
        | 'club_member_app'
        | 'club_employee_app'
        | 'club_offering'
        | 'club_member_registration';

export type AppType = 'end_user' | 'employee';

export type InstitutionType = 'club' | 'kindergarten';

export function getAppId(): AppId | undefined {
    return window.kgrDynamicConfig?.appId as AppId | undefined;
}

export function isAppId(appId: AppId): boolean {
    return getAppId() === appId;
}

export function getAppType(): AppType | undefined {
    return window.kgrDynamicConfig?.appType;
}

export function isAppType(appType: AppType): boolean {
    return getAppType() === appType;
}

export function getInstitutionType(): InstitutionType | undefined {
    return window.kgrDynamicConfig?.institutionType;
}

export function isInstitutionType(institutionType: InstitutionType): boolean {
    return getInstitutionType() === institutionType;
}

export function useAppContext() {
    return { getAppId, isAppId, getAppType, isAppType, getInstitutionType, isInstitutionType };
}
